module.exports = __webpack_public_path__ + "static/media/ashish-profile.bad36ca2.jpg";